import { captureMessage as _captureMessage } from '@sentry/browser'

const captureMessage: typeof _captureMessage = (message, ...otherArgs) => {
  console.error(message)
  return _captureMessage(message, ...otherArgs)
}

export default captureMessage
